import React, { useEffect, useContext, useState } from 'react'

import StepIndicator from '../../components/step-indicator'

import MembershipFormContext from '../../context/membership'
import { getSS } from '../../helpers'


const CardReader: React.FC = () => {

  const membershipForm = useContext(MembershipFormContext)
  const membership_form = (window as any).KEW.collections.membership_form[0]
  const globals = (window as any).KEW.globals
  const [ paypalUrl, setPaypalUrl ] = useState('')

  let membership = getSS('membership')

  function resetForm() {
    (window as any).location.reload()
  }

  useEffect(() => {

    membershipForm.setCurrentStep(4)

    type ObjectProps = {
      [key: string]: any
    }
    let itemsArr = [];
    let invoice = {} as ObjectProps;
    let myItems = {} as ObjectProps;
    let myItem = {} as ObjectProps;

    myItem.name = "Kew Gardens Membership for: " + membership.id;
    myItem.description = membership.selected_membership.description;
    myItem.quantity = "1.0";
    myItem.unitPrice = membership.amount;
    myItem.taxRate = '0.0';
    myItem.taxName = 'Tax';
    itemsArr.push(myItem);
    myItems.item = itemsArr;

    invoice.itemList = myItems;
    invoice.paymentTerms = 'DueOnReceipt';
    invoice.currencyCode = 'GBP';
    invoice.discountPercent = '0';
    invoice.merchantEmail = globals.card_reader_merchant_email;

    if (!membership.email.match(/\+/)) {
      invoice.payerEmail = membership.email;
    };

    var returnUrl = window.location.protocol + '//' + window.location.host + '/membership/' + membership_form.url + '/card-reader/confirm/'+ membership.id + '/';
    var retUrl = encodeURIComponent(returnUrl + "?{result}?Type={Type}&InvoiceId={InvoiceId}&Tip={Tip}&TxId={TxId}&Number={Number}");
    var pphereUrl = "paypalhere://takePayment?returnUrl=" + retUrl;
    pphereUrl = pphereUrl + "&accepted=cash,card,paypal"
    pphereUrl = pphereUrl + "&step=choosePayment";
    pphereUrl = pphereUrl + "&number=" + membership.id;
    pphereUrl = pphereUrl + '&invoice=' + escape(JSON.stringify(invoice));

    setPaypalUrl(pphereUrl)

  }, [membershipForm, globals.card_reader_merchant_email, membership.amount, membership.email, membership.id, membership.selected_membership.description, membership_form.url])

  useEffect(() => {
    if (paypalUrl) {
      (window as any).location = paypalUrl;
    }
  }, [paypalUrl])

  return (
    <form name="membershipForm" autoComplete="on">
      <StepIndicator />
      <div className="row">
        <div className="card-reader-process clearfix box">
          <div className="medium-6 columns">
            <h3>Thank you!</h3>
            <h3>Card reader payment in progress...</h3>
          </div>
          <div className="medium-6 columns">
            <img src={membership.selected_membership.image} alt={membership.selected_membership.alt} />
            <button className="btn-cta" onClick={() => resetForm()} >Reset Form</button>
          </div>
        </div>
      </div>
    </form>
  )
}

export default CardReader